import { createContext, useContext } from 'react'
import { useImmerReducer } from 'use-immer'

const GlobalSearchContext = createContext(null)
const GlobalSearchDispatchContext = createContext(null)

export function GlobalSearchProvider({ children }) {
  const [state, dispatch] = useImmerReducer(
    globalSearchReducer,
    initialGlobalSearch,
  )

  return (
    <GlobalSearchContext.Provider value={state}>
      <GlobalSearchDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalSearchDispatchContext.Provider>
    </GlobalSearchContext.Provider>
  )
}

export function useGlobalSearchContext() {
  return useContext(GlobalSearchContext)
}

export function useGlobalSearchDispatch() {
  const dispatch = useContext(GlobalSearchDispatchContext)

  const reset = () => dispatch({ type: 'reset' })

  const handleComponentSelection = ({
    componentId,
    componentAlias,
    componentStation,
    componentSalesCode,
    locationImageName,
    imageName,
    color,
    alias,
    category,
    partNumber,
  }) => {
    dispatch({
      type: 'component_selected',
      componentId,
      componentAlias,
      componentStation,
      componentSalesCode,
      locationImageName,
      imageName,
      color,
      alias,
      category,
      partNumber,
    })
  }

  const updateComponentAssignedStation = ({ componentStation }) => {
    dispatch({
      type: 'update_component_station',
      componentStation,
    })
  }

  const handleDtcsSelection = ({ dtcs }) => {
    dispatch({
      type: 'dtcs_selected',
      dtcs,
    })
  }

  const handleDtcsSelectionReset = () => {
    dispatch({
      type: 'dtcs_reset',
    })
  }

  const handleSearch = ({ vin, searchString }) => {
    dispatch({
      type: 'search_executed',
      searchString,
      vin,
    })
  }

  const handleRelatedSubsystemComponentId = ({
    relatedSubsystemComponentID,
  }) => {
    dispatch({
      type: 'subsystem_componentId',
      componentId: relatedSubsystemComponentID,
    })
  }
  const handleVisalAidComponentSelection = ({ componentId }) => {
    dispatch({
      type: 'visual_aid_component_selected',
      componentId,
    })
  }
  const handleVisualAidSelection = ({ aidId, fileName, name }) => {
    dispatch({
      type: 'visual_aid_selected',
      aidId,
      name,
      fileName,
    })
  }

  const visualAidReset = () => {
    dispatch({
      type: 'visual_aid_reset',
    })
  }

  return {
    handleSearch,
    handleComponentSelection,
    handleDtcsSelection,
    handleDtcsSelectionReset,
    handleRelatedSubsystemComponentId,
    updateComponentAssignedStation,
    handleVisalAidComponentSelection,
    handleVisualAidSelection,
    visualAidReset,
    reset,
  }
}

function globalSearchReducer(draft, action) {
  switch (action.type) {
    case 'reset': {
      draft.selection = initialGlobalSearch.selection
      break
    }
    case 'component_selected': {
      draft.selection.componentId = action.componentId
      draft.selection.componentAlias = action.componentAlias
      draft.selection.componentStation = action.componentStation
      draft.selection.componentSalesCode = action.componentSalesCode
      draft.selection.locationImageName = action.locationImageName
      draft.selection.alias = action.alias
      draft.selection.color = action.color
      draft.selection.imageName = action.imageName
      draft.selection.category = action.category
      draft.selection.partNumber = action.partNumber
      break
    }
    case 'dtcs_selected': {
      draft.dtcSelection.dtcs = action.dtcs
      break
    }
    case 'dtcs_reset': {
      draft.dtcSelection = initialGlobalSearch.dtcSelection
      break
    }
    case 'search_executed': {
      draft.selection = initialGlobalSearch.selection
      draft.dtcSelection = initialGlobalSearch.dtcSelection
      draft.vin = action.vin
      draft.searchString = action.searchString
      break
    }
    case 'subsystem_componentId': {
      draft.subsystems.componentId = action.componentId
      break
    }
    case 'update_component_station': {
      draft.selection.componentStation = action.componentStation
      break
    }
    case 'visual_aid_selected': {
      draft.visualAid.aidId = action.aidId
      draft.visualAid.name = action.name
      draft.visualAid.fileName = action.fileName
      break
    }
    case 'visual_aid_component_selected': {
      draft.visualAid.componentId = action.componentId
      break
    }
    case 'visual_aid_reset': {
      draft.visualAid = initialGlobalSearch.visualAid
      break
    }
    default: {
      throw Error('Unknown action: ' + action.type)
    }
  }
}

const initialGlobalSearch = {
  vin: null,
  searchString: null,
  dtcSelection: {
    dtcs: [],
  },
  selection: {
    locationImageName: null,
    alias: null,
    color: null,
    imageName: null,
    componentId: null,
    componentSalesCode: null,
    category: null,
    partNumber: null,
  },
  subsystems: {
    componentId: null,
  },
  visualAid: {
    name: null,
    aidId: null,
    fileName: null,
    componentId: null,
  },
}
